import { useMutation } from '@tanstack/react-query';
import api from '../../../lib/api';

interface ApiKeyResponse {
  data: {
    apiKey: string;
    keyId: string;
  };
}

const createPleriApiKey = async () => {
  const { data } = await api.post<ApiKeyResponse>(
    '/api/core/tenant/pleri-api-key',
  );
  return data.data;
};

// Create Pleri API Key
export const useCreatePleriApiKey = () => {
  return useMutation({
    mutationFn: createPleriApiKey,
  });
};
